import { Tab } from "@headlessui/react";
import clsx from "clsx";
import { useState } from "react";

import { Icon, type Icons } from "@web-app/components";

interface SidebarTabProps {
  icon: keyof typeof Icons;
  label: string;
  selectedIcon: keyof typeof Icons;
}

export function SidebarTab({ icon, label, selectedIcon }: SidebarTabProps) {
  const [selected, setSelected] = useState(false);

  return (
    <Tab
      className={({ selected }) => {
        setSelected(selected);
        return clsx(
          "flex items-center justify-start rounded-md p-3 border border-transparent px-6 pl-3 text-sm font-semibold focus:outline-none transition ease-in",
          selected && "text-gray-800 bg-white",
          !selected && "text-gray-500 hover:bg-gray-300 hover:text-gray-700",
        );
      }}
      data-testid={`settings-page-sidebar-${label.toLowerCase()}-tab`}
    >
      <Icon name={selected ? selectedIcon : icon} className="mr-3" />
      {label}
    </Tab>
  );
}
